import FormInputTypes from '../components/atoms/formEnums/formInputTypes';
import { IconType } from '../components/atoms/icon/icon';
import routes from '../routes/route';
import tableSportRoomContentsVT from './tableSportRoomContentsVT';


export default {
  attributeName: 'sportRoomProviders',
  isDragable: false,
  canOpen: false,
  canEdit: true,
  canCreate: true,
  canRemove: false,
  emptyMessage: "You don't have V.T. Providers, click on the \"+\" icon to create one.",
  fields: [
    {
      attributeName: 'providerImage',
      type: FormInputTypes.DOWNLOADABLE,
      label: 'Logo',
      helpText: 'Logo to identify the sku in the app.',
      placeholder: 'Poster URL...',
      canCreate: true,
      canEdit: true,
      fileType:['image/*'],
      exactWidth:'200px'
    },
    {
      attributeName: 'name',
      label: 'Name',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      helpText: 'The name for the item, defined when created on the Developer Dashboard.',
      default: '',
      canEdit: true,
      canCreate: true,
      canFilter: true,
      exactWidth:'500px'

    },
    {
      attributeName: 'sku',
      label: 'SKU',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      helpText: 'The sku for the item, defined when created on the Developer Dashboard.',
      canEdit: false,
      canCreate: true,
      canFilter: true,
    },
    {
      attributeName: 'id',
      label: 'Contents',
      type: FormInputTypes.BUTTON_POPUP,
      icon: IconType.LINK,
      width: '4rem',
      target:'_self',
      iconSize:'2x',
      iconColor:'#17a2b8',
      helpText: 'See the contents of this VT',
      openUrl:'appContentSportRoomVT',
      exactWidth:'100px',
      formConfig:
      {
        title: 'Contents from this VT',
        description:'Contents having this virtual provider',
        attributeName: 'tableContents',
        fields: [
          {
            attributeName: 'SportRoomsContent',
            type: FormInputTypes.TABLE,
            label: '',
            helpText: '',
            configFile: tableSportRoomContentsVT,
          },
        ]
      },
    },   
  ],
};
